import Vue from 'vue'
import Vuex from 'vuex'
import { IState } from './types'
// import * as Cookies from '@/utils/cookie'
import { refreshTokenWithAccount } from '@/api/auth'
import info from './info'
import video from './video'
import order from './order'
import logger from './logger'
import webview from './webviewConfig'
import cart from './cart'
import moment from 'moment'
import { getWebAppCaps } from '@/api/checkout'
Vue.use(Vuex)

const tokenKey = 'userToken'
const tokenExpireTime = 'eco/userExpireTime'
const userInfo = 'eco/userInfo'

const getDefaultState = (): IState => {
  return {
    isInitialized: false,
    token: '',
    expireTime: '',
    isAuthenticated: false,
    coinLeft: 0,
    coinValue: 0,
    nuCoin: 0,
    nuCoinExpireTime: null,
    nickname: '',
    account: '',
    country: null,
    email: '',
    id: '',
    isWebViewMode: false,
    routes: { from: null, to: null },
    showFooter: false,
    webAppCaps: undefined,
    bypassConv: false,
    showNuCoin: true,
    showAddValue: true
  } as IState
}
const state = getDefaultState()

export default new Vuex.Store({
  state,
  modules: {
    info, video, order, logger, webview, cart
  },
  getters: {
    isInitialized: state => state.isInitialized,
    isLogin: state => {
      return state.isAuthenticated
    },
    isFacebookUser: state => {
      return (state.id?.length || '') > 0
    },
    token: state => state.token,
    country: state => state.country,
    isWebViewMode: state => state.isWebViewMode,
    from: state => state.routes.from ? state.routes.from.name : null,
    coinLeft: state => state.coinLeft,
    coinValue: state => state.coinValue,
    nuCoin: state => state.nuCoin,
    nuCoinExpireTime: state => state.nuCoinExpireTime,
    showFooter: state => state.showFooter,
    webAppCaps: state => state.webAppCaps,
    bypassConv: state => state.bypassConv
  },
  mutations: {
    INITIALIZE_TOKEN: state => {
      // state.token = Cookies.getToken() || ''
      // state.expireTime = Cookies.getTokenExpiredTime() || ''
      // Use localStorage instead of cookies
      state.token = localStorage.getItem(tokenKey) || ''
      state.expireTime = localStorage.getItem(tokenExpireTime) || ''
      const expireTime = moment(state.expireTime)
      const currentTime = moment()
      if (state.isWebViewMode) {
        state.isAuthenticated = state.token.length > 0
      } else {
        if (state.token.length > 0 && currentTime < expireTime) {
          state.isAuthenticated = true
        }
      }
      console.log('Init token, result:', state.isAuthenticated)
    },
    SET_TOKEN (state, payload) {
      if (!payload) return
      if (payload.token) {
        state.isAuthenticated = payload.token.length > 0
        state.expireTime = payload.expire_time
        state.token = payload.token
        // const expireTime = moment(state.expireTime)
        //  currentTime = moment()
        // const expireDays = expireTime.diff(currentTime, 'days', true)
        localStorage.setItem(tokenKey, payload.token)
        localStorage.setItem(tokenExpireTime, payload.expire_time)
        // Cookies.setToken(payload.token, expireDays)
        // Cookies.setTokenExpiredTime(payload.expire_time, expireDays)
        state.isInitialized = true
      }
    },
    SET_TOKEN_ONLY (state, token) {
      state.token = token
    },
    SET_COIN_LEFT (state, coinLeft) {
      if (coinLeft >= 0) {
        state.coinLeft = coinLeft
      }
    },
    SET_COIN_VALUE (state, coinValue) {
      if (coinValue >= 0) {
        state.coinValue = coinValue
      }
    },
    SET_NU_COIN (state, nuCoin) {
      if (nuCoin >= 0) {
        state.nuCoin = nuCoin
      }
    },
    SET_NU_COIN_EXPIRE_TIME (state, nucoinExpireTime) {
      state.nuCoinExpireTime = nucoinExpireTime
    },
    RESET (state) {
      localStorage.removeItem(tokenKey)
      localStorage.removeItem(tokenExpireTime)
      localStorage.removeItem(userInfo)
      Object.assign(state, getDefaultState())
    },
    INITIALIZE_USER_INFO: state => {
      // const payload = Cookies.getUserInfo()
      const dataStr = localStorage.getItem(userInfo)
      const payload = dataStr ? JSON.parse(dataStr) : undefined
      if (!payload) return
      state.nickname = payload.nickname || payload.name || ''
      state.account = payload.account ? payload.account : ''
      state.email = payload.email ? payload.email : ''
      state.id = payload.id ? payload.id : ''
      console.log('Init user info')

      // Update expireTime in Safari 7 days first-part cookie restriction
      // state.expireTime = Cookies.getTokenExpiredTime() || ''
      // const expireTime = moment(state.expireTime)
      // const currentTime = moment()
      // Cookies.setUserInfo(payload, expireTime.diff(currentTime, 'days', true))
    },
    SET_USER_INFO (state, payload) {
      const nickname = state.nickname = payload ? payload.nickname || payload.name || '' : ''
      const account = state.account = payload ? payload.account : ''
      const email = state.email = payload ? payload.email : ''
      const id = state.id = payload ? payload.id : ''
      const data = { nickname, account, email, id }
      // const expireTime = moment(state.expireTime)
      // const currentTime = moment()
      localStorage.setItem(userInfo, JSON.stringify(data))
      // Cookies.setUserInfo(data, expireTime.diff(currentTime, 'days', true))
    },
    SET_ROUTES (state, payload) {
      state.routes = payload
    },
    SET_WEBVIEW_MODE (state, webview) {
      if (webview === '1' || webview === 1 || webview === true) {
        state.isWebViewMode = true
      } else {
        state.isWebViewMode = false
      }
      console.log(`Init webview: ${state.isWebViewMode}`)
    },
    SET_COUNTRY (state, country) {
      state.country = country
      if (country) { localStorage.setItem('eco/country', country) }
    },
    SET_FOOTER (state, isShow) {
      state.showFooter = isShow
    },
    SET_WEBAPPCAPS (state, payload) {
      state.webAppCaps = payload
    },
    SET_BYPASS_CONV (state, payload) {
      state.bypassConv = payload
    }
  },
  actions: {
    async REFRESH_TOKEN ({ commit, state, getters }) {
      try {
        if (state.isAuthenticated === false) return
        if (state.token === '') { commit('INITIALIZE_TOKEN') }
        if (state.account === '') { commit('INITIALIZE_USER_INFO') }
        const expireTime = moment(state.expireTime)
        const currentTime = moment()
        const diff = expireTime.diff(currentTime, 'days')
        // According to the diff, if token will expire in 7 days, set refresh_token = 1

        const requestBody = {
          account: state.account,
          token: state.token,
          type: getters.isFacebookUser ? 1 : 0,
          refresh_token: diff <= 7 ? 1 : 0
        }
        const { data } = await refreshTokenWithAccount(requestBody)

        if (data.flag === 0) {
          commit('SET_TOKEN', data)
          // const userInfo = Cookies.getUserInfo()
          const u = localStorage.getItem(userInfo)
          const setUserInfo = u ? JSON.parse(u) : {}
          setUserInfo.expireTime = data.expire_time
          commit('SET_USER_INFO', setUserInfo)
          commit('SET_COIN_LEFT', parseInt(data.coin_left) || 0)
          commit('SET_NU_COIN', parseInt(data.nucoin) || 0)
          commit('SET_COIN_VALUE', parseInt(data.coin_value) || 0)
          commit('SET_NU_COIN_EXPIRE_TIME', data.nucoin_expire_time)
          console.log(`Refreshed token: ${currentTime > expireTime ? 1 : 0}`)
          return Promise.resolve(true)
        } else {
          commit('RESET')
          return Promise.reject(data.msg)
        }
      } catch (error) {
        console.error(error)
        return Promise.reject(error)
      }
    },
    async GET_WEBAPPCAPS ({ commit, state, getters }) {
      if (state.webAppCaps) { return Promise.resolve(state.webAppCaps) }
      try {
        console.log({ ver_no: getters['webview/ver_no'] })
        const { data } = await getWebAppCaps({ ver_no: getters['webview/ver_no'] })
        commit('SET_WEBAPPCAPS', data)
        if (typeof data.bypass_conv !== 'undefined') {
          commit('SET_BYPASS_CONV', data.bypass_conv)
        }
        return Promise.resolve(data)
      } catch (error) {
        console.log(error)
        commit('logger/PUSH_LOG', 'GetAppCaps error')
        commit('logger/PUSH_LOG', error)
        return Promise.reject(error)
      }
    }
  }
})
